// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import messages from './i18n'
import Transitions from 'vue2-transitions'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import VueLocalStorage from 'vue-localstorage'
import { VueMaskDirective } from 'v-mask'
import Vue2Filters from 'vue2-filters'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueSelectImage from 'vue-select-image'
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)
Vue.use(VueSelectImage)
// add stylesheet
require('vue-select-image/dist/vue-select-image.css')
Vue.use(VueFormWizard)
Vue.use(Vue2Filters)
Vue.directive('mask', VueMaskDirective)
Vue.use(VueI18n)
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
// eslint-disable-next-line
// Vue.axios.defaults.headers.common['X-WP-Nonce'] = wp_membership_sale.nonce
// Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZGV2Lmhpc3Bhbm9jbHViLmNvbSIsImlhdCI6MTUzNzMxNDM3MiwibmJmIjoxNTM3MzE0MzcyLCJleHAiOjE1Mzc5MTkxNzIsImRhdGEiOnsidXNlciI6eyJpZCI6IjM0MyJ9fX0.SniHhzckdNCMeNBMJ84Wi3qId7T0ARcA_t_oSqcth0U'
// Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZGV2Lmhpc3Bhbm9jbHViLmNvbSIsImlhdCI6MTUzNzI5Nzc3NywibmJmIjoxNTM3Mjk3Nzc3LCJleHAiOjE1Mzc5MDI1NzcsImRhdGEiOnsidXNlciI6eyJpZCI6IjEifX19._qfPtJYVpfN6h2HQsxX7FXWSsedkU7Lrk7JGDBWfSdI'
// eslint-disable-next-line
Vue.axios.defaults.baseURL = wp_membership_sale.rootREST
Vue.use(VueMomentJS, moment)
Vue.use(Transitions)
Vue.use(VueLocalStorage)
const i18n = new VueI18n({
  // eslint-disable-next-line
  locale: wp_membership_sale.lang, // set locale
  // locale: 'en',
  fallbackLocale: 'en',
  messages
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app-hc-sale-proccess',
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js